export const STORAGEKEY = {
  SESSION_ID: "SESSION_ID",
  STORE_NAME: "storeName",
  TABLE_NO: "tableNo",
  QR_CODE: "QRCode",
  DINING_MODE: "selectiDineOption"
};
